import {
  type SiteDetailResponse,
  type SiteResponse,
  SiteType,
} from '@on3/api/src';
import { Check } from '@on3/ui-lib/components/Svg';
import { createDescription, createTitle } from '@public/utils/meta';

import styles from './JoinOneSubscription.module.scss';

export const JoinOneSubscription = ({
  details,
  site,
}: {
  details: SiteDetailResponse | null;
  site: SiteResponse;
}) => {
  const isTeam = site?.isTeam;
  const title = isTeam ? 'One subscription' : "What's included";
  const subheading = isTeam
    ? createDescription(
        'Together, {0} and On3 create the largest community of college sports fans online — the ultimate home for {1} coverage, recruiting news, and fan conversation. Join today.',
        site?.name || 'the site',
        site?.organization?.mascot || 'your favorite team',
      )
    : null;

  const benefits = [
    {
      title: 'Exclusive Insider Access',
      description: createDescription(
        'Coverage from {0} insiders, and more',
        site?.type === SiteType.Team ? site.name : 'On3',
      ),
    },
    {
      title: isTeam
        ? createTitle(
            'Largest',
            site?.organization?.knownAs || site?.organization?.name,
            'Fan Community',
          )
        : 'Largest Fan Communities',
      description: isTeam
        ? createDescription(
            'Market leading home for {0} fans',
            site?.organization?.mascot || "your team's",
          )
        : 'Market leading home for all College Sports fans',
    },
    {
      title: 'Full Network Access',
      description:
        'Insider coverage from every fan site across the On3 Network',
    },
    {
      title: 'On3 National College Voices You Trust',
      description:
        'Andy Staples, Chris Low, Brett McMurphy, Pete Nakos, Ross Dellenger, Field of 68, and others',
    },
    {
      title: 'Rivals Recruiting',
      description:
        'The most trusted recruiting brand in the game, led by Steve Wiltfong, Chad Simmons, Joe Tipton, and more',
    },
    {
      title: 'Bonus Member Perks',
      description:
        'Complimentary access to The Athletic for 1 year (Annual plan only), and others',
    },
  ];

  return (
    <section>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2>{title}</h2>
          {subheading && <p>{subheading}</p>}
          {isTeam && (
            <h3 className={styles.subtitle}>
              <span>What&apos;s included</span>
            </h3>
          )}
        </header>
        <ul className={styles.benefits}>
          {benefits.map((benefit, idx) => (
            <li className={styles.benefit} key={idx}>
              <Check />
              <div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
